import React from 'react'
import getTranslationTime from '../functions/getTranslationTime'
import Translation from '../General/Translation'


const CinemaStart = ({startingDate, translation }) => {
    if(startingDate === '' || !startingDate) {
        return ''
    } else {
        return <p className="text-light cinema-start-date"><span className="typo-color-muted"><Translation id="cinemaRelease" trans={translation}>Kinostart</Translation>: </span> {getTranslationTime("cinemaStart", translation, startingDate)}</p>
    }
}


export default CinemaStart